










































import { login } from "@/api/user";
import Vue from "vue";
export default Vue.extend({
  name: "login",
  data() {
    return {
      user: {
        user_name: "",
        password: "",
      },
    };
  },
  methods: {
    doLogin() {
      if (!this.user.user_name) {
        this.$message.error("请输入用户名！");
        return;
      } else if (!this.user.password) {
        this.$message.error("请输入密码！");
        return;
      } else {
        //校验用户名和密码是否正确;
        login(this.user.user_name, this.user.password).then((res) => {
          console.log("输出response.data.status", res);
          if (res) {
            this.$store.commit("Login",res)
            this.$router.push({ path: "/" });
          } else {
            alert("您输入的用户名或密码错误！");
          }
        });
      }
    },
  },
});
